var Reverb = window.Reverb || {};
Reverb.AjaxLoadAndReplace = (function () {
  // Loads content via ajax into a container.
  // Example:
  //    <div id='mycontainer'>this will be replaced by the contents returned from the link</div>
  //    <a href="/path/to/get/content" data-ajax-load-into="#mycontainer">Click Me To Load into #mycontainer</a>
  function ajaxLoadInto() {
    $(document).on('click', 'a[data-ajax-load-into]', function (e) {
      e.preventDefault();

      var clickedLink = $(this);
      var $container = $(clickedLink.data('ajax-load-into'));

      $container.load(clickedLink.prop('href'));
    });
  }

  // Loads content via ajax, slides the old containter up,
  // while sliding down the new content. When slide up is
  // finished, the old container is removed.
  function ajaxSlideReplace() {
    var linkSelector = 'a[data-ajax-slide-replace]';
    $(document).on('click', linkSelector, function (e) {
      e.preventDefault();

      var $clickedLink = $(this);
      var disableWithText = $clickedLink.data('ajax-slide-disable-with');
      var $container = $($clickedLink.data('ajax-slide-replace'));

      var url = $clickedLink.prop('href');
      var req = Reverb.APIRequest.get(url);

      if (disableWithText) {
        $($clickedLink).addClass('btn-disabled').html(disableWithText);
      }

      req.done(function (content) {
        $(content).insertAfter($container).slideDown('slow');
        $container.slideUp('slow', function () {
          $container.remove();
        });
      });
    });
  }

  function ajaxAppendTo() {
    $(document).on('click', 'a[data-ajax-append-to]', function (e) {
      e.preventDefault();

      var link = $(this);
      var container = $(link.data('ajax-append-to'));

      var url = link.prop('href');
      var req = Reverb.APIRequest.get(url);

      req.done(function (content) {
        container.append(content);
        link.trigger('reverb.ajax.append-to.complete');
      });
    });
  }

  // After submitting an ajax button, we may want to refresh its container
  // We look for the container that has the "ajax-refresh-from" data attribute, and
  // pull that attribute to get the new source
  function ajaxRefreshFrom() {
    $(document).on('ajax:success', '[data-ajax-refresh-from]', function (e) {
      var container = $(this);
      container.load(container.data('ajax-refresh-from'));
    });
  }

  // Specifies that the results of a remote form should populate a dom element
  // Example:
  //  .results
  //    # content will go here after the form executes
  //
  //  = form_tag foo_url, data: {"ajax-load-into" => ".results"}
  //    = submit_tag
  //

  function bindAjaxLoadIntoForms() {
    $(document).on('submit', 'form[data-ajax-load-into]', function (e) {
      e.preventDefault();
      var $target = $(e.target);
      var $form = $(this);
      var containerSelector = $target.data('ajax-load-into');

      ajaxLoadIntoForms($form, $target, containerSelector);
    });
  }

  // This function takes a selector for container because we want to trigger an event
  // on the container AFTER it has been replaced, which means we need to find it again
  function ajaxLoadIntoForms(form, spinnerTarget, containerSelector, callBack) {
    return remoteSubmitWithSpinner(form, spinnerTarget).done(function (xhr) {
      $(containerSelector).replaceWith(xhr.responseText);
      $(containerSelector).trigger('reverb.ajax_load.complete');

      if (callBack) {
        callBack();
      }
    });
  }

  // Specifies that the results of a remote form should replace an element
  // Example:
  //  .results
  //    # content will go here after the form executes
  //
  //  = form_tag foo_url, data: {"ajax-replace" => ".results"}
  //    = submit_tag
  //
  function ajaxReplaceForms() {
    $(document).on('submit', 'form[data-ajax-replace]', function (e) {
      e.preventDefault();
      var $target = $(e.target);
      var $form = $(this);

      remoteSubmitWithSpinner($form, $target).done(function (xhr) {
        var containerSelector = $target.data('ajax-replace');
        $(containerSelector).replaceWith(xhr.responseText);
        initTips(containerSelector);
      });
    });
  }

  function remoteSubmitWithSpinner(form, $target) {
    return remoteSubmit(form).progress(function () {
      $target.spin();
    }).done(function () {
      $target.stopSpinner();
    });
  }

  function remoteSubmit(form) {
    var promise = new $.Deferred();
    form.on('ajax:beforeSend', function (e) {
      promise.notify();
    });
    form.on('ajax:success', function (e, xhr) {
      promise.resolve(xhr);
    });
    form.on('ajax:error', function (e, xhr) {
      promise.resolve(xhr);
    });
    $.rails.handleRemote(form);
    return promise;
  }

  function init() {
    ajaxSlideReplace();
    ajaxLoadInto();
    ajaxRefreshFrom();
    bindAjaxLoadIntoForms();
    ajaxReplaceForms();
    ajaxAppendTo();
  }

  return {
    init: init,
    ajaxLoadIntoForms: ajaxLoadIntoForms
  };
})();

Reverb.AjaxLoadAndReplace.init();



// WEBPACK FOOTER //
// ./javascripts/components/legacy/ajax_load_and_replace.js